module.exports = __webpack_public_path__ + "img/logo.5699fff0.png";